/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2020 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

import {
    MapTo,
    withComponentMappingContext,
    AllowedComponentsContainer,
} from '@adobe/aem-react-editable-components';

export const ContainerConfig = {
    emptyLabel: 'Container',

    isEmpty: function (props) {
        return !props || !props.cqItemsOrder || props.cqItemsOrder.length === 0;
    },
};

export default MapTo('cob-corp-acquisition/components/container')(withComponentMappingContext(AllowedComponentsContainer), ContainerConfig);
